import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{staticClass:"dialog-footer",attrs:{"color":"white","fixed":"","elevation":"5","padless":""}},[_c(VRow,{attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"6"}},[_vm._t("footer-content")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }